import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import HKVMarkdown from "../components/HKVMarkdown/4.0"

import { fetchLocalFile } from "../store/reducers/functions"

import moment from "moment"

const OverLVO = () => {
  const dispatch = useDispatch()

  const [markdown, setMarkdown] = useState()

  useEffect(() => {
    dispatch(fetchLocalFile("/static/markdown/over_lvo.md?20260429", "text"))
      .then((md) => {
        setMarkdown({ key: moment().valueOf(), source: md })
      })
  }, [])

  return (
    <div className="page-landing">
      <section className="brick">
        <section className="section">
          <HKVMarkdown
            key={markdown?.key}
            source={markdown?.source}
            className="rich-text-full"
          />
        </section>
      </section>
    </div>
  )
}

export default React.memo(OverLVO)